export default "__VITE_ASSET__948ac3f2__"